export const OtherIcon = ({
  strokeColor = "var(--color-txt-secondary)",
  ...props
}: any) => (
  <svg width={16} height={16} fill="none" {...props}>
    <path
      fill="var(--color-icon-bright)"
      stroke="var(--color-icon-bright)"
      strokeWidth={0.1}
      d="M7.997 15.714c-.48 0-.968-.122-1.399-.373L2.337 12.88a2.817 2.817 0 0 1-1.4-2.425V5.548c0-.998.539-1.923 1.4-2.425L6.598.662a2.786 2.786 0 0 1 2.798 0l4.262 2.46a2.817 2.817 0 0 1 1.399 2.426v4.907c0 .997-.538 1.923-1.4 2.425l-4.26 2.46c-.431.252-.92.374-1.4.374Zm0-14.35c-.294 0-.595.08-.86.23L2.874 4.055c-.531.309-.861.876-.861 1.493v4.907c0 .61.33 1.184.86 1.492l4.262 2.461c.531.309 1.191.309 1.722 0l4.262-2.46c.53-.31.86-.876.86-1.493V5.548c0-.61-.33-1.184-.86-1.493l-4.262-2.46a1.758 1.758 0 0 0-.86-.23Z"
    />
    <path
      fill="var(--color-icon-bright)"
      stroke="var(--color-icon-bright)"
      strokeWidth={0.1}
      d="M7.903 8.099a2.293 2.293 0 0 1 0-4.583 2.293 2.293 0 0 1 0 4.583Zm0-3.467c-.647 0-1.176.528-1.176 1.175s.529 1.176 1.176 1.176c.647 0 1.175-.529 1.175-1.176 0-.647-.528-1.175-1.175-1.175ZM10.877 12.311a.562.562 0 0 1-.558-.558c0-1.027-1.086-1.867-2.418-1.867s-2.418.84-2.418 1.867a.562.562 0 0 1-.558.558.562.562 0 0 1-.558-.558c0-1.644 1.585-2.983 3.534-2.983 1.95 0 3.534 1.339 3.534 2.983a.562.562 0 0 1-.558.558Z"
    />
  </svg>
);
